import { connectedLimitOrderSections } from 'components/secondaryMarket/limitOrder/sections.connect';

export const LimitOrderQuotesSections = connectedLimitOrderSections('secondaryMarketQuotes');
